import { useContext } from "react";
// import { FormContextMA } from "../form-context";
import { ProvinceAbbreviations } from "../../../helpers/constant";
import {
  formatPhone,
  formatPhoneDocumentation,
} from "../../../helpers/functions";
import { countryOptions } from "../../patient/create/options";
import { DataField, Divider, H2, H3, Section, P } from "./common-components";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";
import { GetPatientAddress } from "../common/GetPatientAddress";

export const PatientContactInformation = ({ formType, patient }) => {
  // const { formType, patient } = useContext(FormContextMA);
  
  // Check if this is an intervention form
  const isInterventionForm = (() => {
    if (!formType) return false;
    const lowerFormType = formType.toLowerCase();
    return lowerFormType.includes("intervention") || lowerFormType.includes("prescribing");
  })();
  
  return (
    <>
      {isInterventionForm ? (
        // Intervention form layout - vertical fields (no Section wrapper)
        <div className="px-4 border-0 p-2">
          <H2>Patient Contact Information</H2>
          <div className="flex-1 pr-2 py-0 space-y-1">
            <div className="grid grid-cols-1">
              <DataField
                label="Primary Phone number"
                value={
                  patient?.contactInfo?.primaryPhone
                    ? formatPhoneDocumentation(patient.contactInfo.primaryPhone)
                    : ""
                }
              />
            </div>
            <div className="mt-2">
              <DataField
                label="Secondary Phone"
                value={
                  patient?.contactInfo?.secondaryPhone
                    ? formatPhoneDocumentation(patient.contactInfo.secondaryPhone)
                    : ""
                }
              />
            </div>  
            <DataField
              label="Email Address"
              value={patient?.contactInfo?.email || patient?.email || ""}
            />
          </div>
        </div>
      ) : (
        <Section formType={formType}>
          <H2>Patient Contact Information</H2>
          <div className="grid grid-cols-2 gap-1">
        {patient?.contactInfo?.primaryPhone ||
        patient?.contactInfo?.secondaryPhone ? (
          <>
            {patient?.contactInfo?.primaryPhone ? (
              <DataField
                label="Primary Phone Number"
                value={
                  patient?.contactInfo?.primaryPhone
                    ? formatPhoneDocumentation(patient.contactInfo.primaryPhone)
                    : ""
                }
              />
            ) : null}
            {![
              AllergicRhinitisDocTypes.PhysicianReferralForm
            ].includes(formType) && patient?.contactInfo?.secondaryPhone ? (
              <DataField
                label="Secondary Phone"
                value={
                  patient?.contactInfo?.secondaryPhone
                    ? formatPhoneDocumentation(
                        patient.contactInfo.secondaryPhone
                      )
                    : ""
                }
              />
            ) : null}
          </>
        ) : (
          <>
            <H3>No Phone Information</H3>
            <br />
          </>
        )}
        {patient?.contactInfo?.email ? (
          <DataField
            label="Email Address"
            value={patient.contactInfo.email || ""}
          />
        ) : (
          <H3>No Email Address</H3>
        )}
      </div>

        {[AllergicRhinitisDocTypes.InitialAssessment, MedicationReviewDocTypes.PharmacistWorksheet].includes(formType) ? (
          <>
            <Divider />
            <GetPatientAddress patient={patient} />
          </>
        ) : null}
        </Section>
      )}
    </>
  );
};
